<template>
  <el-timeline>
    <el-timeline-item :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
                      :timestamp="item.updateTime" placement="top" v-for="item in logData">
      <el-card>
        <h3>{{ item.version }}</h3>
        <h4 v-if="item.update && item.update.length > 0">更新:</h4>
        <ul>
          <li v-for="itemInner in item.update"><i class="iconfont icon-dian"></i>{{ itemInner }}</li>
        </ul>
        <h4 v-if="item.optimize && item.optimize.length > 0">优化:</h4>
        <ul>
          <li v-for="itemInner in item.optimize"><i class="iconfont icon-dian"></i>{{ itemInner }}</li>
        </ul>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</template>

<script>
export default {
  name: 'Log',
  data() {
    return {
      logData: [
        {
          updateTime: "2022/11/02",
          version: "1.0.0",
          update: [
            "登录，修改密码；",
            "用户管理：管理员可以对管理员、分析人员、销售进行增加、修改、删除操作；分析人员可以对销售进行增加、编辑操作；",
            "创建项目：分析人员功能；",
            "修改样本名：销售、客户可以对原始数据文件中的样本名进行修改;",
            "分组文件管理: 销售、客户功能，可以上传分组文件，对分组文件进行编辑、删除和批量删除；",
            "分析管理: 可以通过该项目对应的样本文件和分组文件创建分析，执行成功后可以下载结果文件，可以对项目号进行编辑。"
          ],
          optimize: [],
          size: "large"   //normal / large
        }]
    }
  },
}
</script>

<style scoped>

h3 {
  margin-top: 0;
  font-size: 25px;
}

h4 {
  font-size: 16px;
}

.el-card ul li {
  height: 25px;
  line-height: 25px;
  font-weight: 600;
}
</style>
